import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { createPsAxiosInstance } from '@patsnap/common-ps-http';
import { inject, injectable } from 'inversify';
import { Symbols } from '../../../symbols';
import { format } from '@/@core/utils/string';
const ANALYTICS_URLS = {
    CI: 'https://ci-basic-service.zhihuiya.com',
    QA: 'https://qa-basic-service.zhihuiya.com',
};
let EmailTemplateManagementApi = class EmailTemplateManagementApi {
    constructor(http, analyticsUrls, emailTemplateUrls) {
        this.http = http;
        this.analyticsUrls = analyticsUrls;
        this.emailTemplateUrls = emailTemplateUrls;
        this.analyticsHttp = createPsAxiosInstance().psHttp;
        this.aggregation = (params, token) => {
        };
        this.image2Code = (params) => {
            const sock = new WebSocket('wss://qa-station-service.patsnap.info/screenshot2code-api/generate-code');
            sock.onopen = () => {
                console.log('open');
                sock.send(JSON.stringify(params));
            };
            sock.onmessage = (event) => {
                console.log(event.data);
            };
            sock.onclose = () => {
                console.log('close');
            };
            sock.onerror = (event) => {
                console.log('error', event);
            };
        };
        this.sendMail = (email, htmlContent) => {
            return this.http.post({
                url: this.emailTemplateUrls.sendMail,
                data: {
                    email,
                    content: htmlContent,
                },
            });
        };
        this.updateBasic = (params) => {
            return this.http.put({
                url: format(this.emailTemplateUrls.updateBasicInfo, { id: params.id }),
                data: params,
            });
        };
        this.updateContentTemplate = (params) => {
            return this.http.put({
                url: format(this.emailTemplateUrls.updateContentTemplate, { id: params.id }),
                data: params,
            });
        };
        this.updateContentMock = (params) => {
            return this.http.put({
                url: format(this.emailTemplateUrls.updateContentMock, { id: params.id }),
                data: params,
            });
        };
        this.updateContentI18n = (params) => {
            return this.http.put({
                url: format(this.emailTemplateUrls.updateContentI18n, { id: params.id }),
                data: params,
            });
        };
        this.deleteTemplate = (id) => {
            const url = format(this.emailTemplateUrls.deleteTemplate, { id });
            return this.http.delete({
                url,
            });
        };
        this.listPagination = (params) => {
            const { sEcho, iDisplayStart, iDisplayLength, ...other } = params;
            return this.http.post({
                url: this.emailTemplateUrls.listPagination,
                params: {
                    sEcho,
                    iDisplayStart,
                    iDisplayLength,
                },
                data: other,
            });
        };
        this.preview = (previewParams, options) => {
            return this.http.post({
                url: localStorage.getItem('EMAIL_RENDERER_PREVIEW_URI') || this.emailTemplateUrls.preview,
                headers: {
                    Accept: 'text/html',
                },
                params: options,
                data: previewParams,
            });
        };
        this.getTemplate = (id) => {
            const url = format(this.emailTemplateUrls.getTemplate, { id });
            return this.http.get({
                url,
            });
        };
        this.addTemplate = (data) => {
            const url = this.emailTemplateUrls.addTemplate;
            return this.http.post({
                url,
                data,
            });
        };
        this.publishLocalTemplate = (env, template) => {
            // 线上后端没法直接发布CI和QA环境，需要前端直接调对应环境的basic服务，但此步没法更新发布历史，需要后面再调发布接口
            if (!ANALYTICS_URLS[env]) {
                return Promise.resolve();
            }
            return this.analyticsHttp({
                method: 'post',
                headers: {
                    'X-Prompt-IDENTITY': 'AuqK3hJrPwslj2YVVQWhNQpNSm5VbXQPUfbYqiI8v7Lmi9pdgGZbhgCUPcvYHIYppVxQXmgK9X8uyLUNA1dL6hJXCHrmxPG9uL0RhQH5xZDUTNQEzX2hsQRFvnJevhg',
                },
                baseURL: ANALYTICS_URLS[env],
                url: this.analyticsUrls.publishTemplate,
                data: _.pick(template, ['format', 'template_key', 'content', 'i18n']),
            });
        };
        this.publishUpdateTemplate = (params) => {
            // 线上后端只能发布release/线上环境，CI/QA需要前端直接调对应环境的basic服务，再调此接口
            return this.http.post({
                url: this.emailTemplateUrls.publishTemplate,
                data: params,
            });
        };
    }
};
EmailTemplateManagementApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.AnalyticsEmailTemplateUrls)),
    __param(2, inject(Symbols.EmailTemplateManagementUrls)),
    __metadata("design:paramtypes", [Object, Object, Object])
], EmailTemplateManagementApi);
export { EmailTemplateManagementApi };
